var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about",attrs:{"id":"page"}},[_c('h1',[_vm._v("Super Admin Page")]),_c('router-link',{staticClass:"nav-btn",attrs:{"to":{ name:'UserManagement' }}},[_vm._v(" UserManagement ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }